import { createAction } from '@reduxjs/toolkit';

const addCollections = createAction('archive/addCollections');

export default addCollections;
